import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';

import { admin as manager } from '@/service/api/manager';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'created_at', sortable: true, label: 'Joined_at'},  // Todo : label 변경해야함 -> 해당 내용 생성날짜임에도 불구하고 사용자가 보았을때 무엇을 뜻하는지 모름
    { key: 'status', label: 'Allow login' },
    { key: 'permissions', sortable: false, label: 'Permission'},
    { key: 'username', sortable: true, label: 'Username'},
    { key: 'nickname', sortable: true, label: 'Nickname' },
    { key: 'last_visit', label: 'Last_visit', sortable: true },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'created_at', sortable: true, label: '가입일'},
    { key: 'status', label: '로그인 허용' },
    { key: 'permissions', sortable: false, label: '권한'},
    { key: 'username', sortable: true, label: '사용자명'},
    { key: 'nickname', sortable: true, label: '이름' },
    { key: 'last_visit', label: '마지막 접속일', sortable: true },
  ]
}

export default {
  components: { DatePicker, vSelect },
  props : ["auto_refresh", "enable_new", "view_detail",'only_select'],
  name : "partnerList",
  data: () => ({
    hide_del : true,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 }, //enable : is_alive 기준, disable : is_del 기준
    sync : { interval : 15, stop : false, th : undefined },
    nbsp : "\u00A0"
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['last_visit_ed'] = moment();
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_verified':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return manager.listAdmin(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      manager.summaryAdmin({ ts : new Date().getTime() })
        .then(rs => { this.model = Object.assign(this.model, { enable : (rs.body.total - rs.body.disable), disable : rs.body.disable, total : rs.body.total }); })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    goDetail(item){
      this.$router.push({ name : 'admin', params : { id: item.id } })
    },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.$on('refresh', this.refresh()) } },
  created() { console.log('Admin_list.vue', 'created'); },
  destroyed() { console.log('Admin_list.vue', 'destroyed'); },
  mounted() {
    console.log('Admin_list.vue', 'mounted');
    if(this.view_detail !== false) { this.summary(); }
  },
}